import { IDerivedColumnDraft } from '../../../../redux/slices/dataModeler';
import React from 'react';
import KubitContextualMenu from '../../../../components/Dropdown/ContextualMenu/KubitContextualMenu';
import useDerivedColumnCopyDefinitionMenuItems from './useDerivedColumnCopyDefinitionMenuItems';
import { MenuTriggerDiv } from './DataModelerDerivedColumnCopyDefinitionUI';

interface IProps {
  updateDraft: (props: Partial<IDerivedColumnDraft>) => void;
}

const DataModelerDerivedColumnCopyDefinition = ({ updateDraft }: IProps) => {
  const menuItems = useDerivedColumnCopyDefinitionMenuItems({ updateDraft });
  return (
    <KubitContextualMenu
      items={menuItems}
      trigger={<MenuTriggerDiv>Copy definition from</MenuTriggerDiv>}
    />
  );
};

export default DataModelerDerivedColumnCopyDefinition;
